// extracted by mini-css-extract-plugin
export var actions = "bK_fH";
export var content = "bK_9";
export var headline = "bK_fG";
export var imageContainer = "bK_bH";
export var singleCtaContainer = "bK_fD";
export var variant = "bK_fF";
export var wrapper = "bK_bZ";